export const DOWNLOAD_SECTION_DATA_TEST_ID = 'downloadSection';
